<template>
  <p class="font-weight-bold text-right mb-0">ผ่านไปแล้ว: {{ elapsedTime }}</p>
</template>

<script>

import moment from 'moment';
export default {
  name: 'Countup',
  props: {
    start: { type: Date, required: true, default: Date.now }, // กำหนดเวลาต้นทาง
    name: { type: String, required: true }, // เช่น 'mfu-home'
    size: { type: String, default: 'md' }
  },
  data () {
    return {
      now: moment(),
      timer: null
    }
  },
  computed: {
    elapsedTime() {
      const duration = moment.duration(this.now.diff(this.start));
      const totalSeconds = Math.floor(duration.asSeconds());
      const days = duration.days();
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();
      const parts = [];
      if (totalSeconds >= 86400) {
        parts.push(`${days} วัน`);
      }
      if (totalSeconds >= 3600) {
        parts.push(`${hours} ชั่วโมง`);
      }
      if (totalSeconds >= 60) {
        parts.push(`${minutes} นาที`);
      }
      parts.push(`${seconds} วินาที`);
      return parts.join(' ');
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      this.now = moment();
    }, 1000);
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }
}
</script>
